module Widgets.Checkbox where

import Prelude

import Concur.Core (Widget)
import Concur.React (HTML)
import Concur.React.DOM as D
import Concur.React.Props as P


-- | Checkbox with a label and the given ID.
-- |
-- | The given ID is used both as the label ID and the react key, and must be
-- | unique within the entire page.
labelCheckbox' :: String -> String -> String -> Boolean -> Widget HTML Boolean
labelCheckbox' cls id label checked = D.div
    [ P.key id, P.className cls ]
    [ checkbox [ P._id id ] checked
    , D.label [ P.htmlFor id, P.className "mx-3" ] [ D.text label ]
    ]

-- | Checkbox with a label and the given ID.
-- |
-- | The given ID is used both as the label ID and the react key, and must be
-- | unique within the entire page.
labelCheckbox :: String -> String -> Boolean -> Widget HTML Boolean
labelCheckbox = labelCheckbox' ""

-- | Displays a checkbox with the given state and returns the new state when
-- | it's clicked.
checkbox :: Array (P.ReactProps Boolean) -> Boolean -> Widget HTML Boolean
checkbox props checked =
    D.input ([P._type "checkbox", P.checked checked, not checked <$ P.onChange] <> props)
